module.exports = __webpack_public_path__ + "static/appreciate-ca8518411ffd120b5e470138ae109b34.png";